<!-- Nothing renders until we know this page has something to review: while the loader is up, and when every
     review section is off so the final submit popup opens instead, the page stays blank behind it. -->
<ng-container *ngIf="!(loading$ | async) && stepVisibilityResolved && !finalSubmitModalOpened">
    <savvy-stepper *ngIf="institutionSettings.flow === '2'"></savvy-stepper>
    <div class="main-title">
        <h1 class="heading" data-test-id="review.title">
            {{ contentService.getContentText('REVIEW.HEADLINE') }}
        </h1>
    </div>

    <mat-stepper #reviewPageStepper [linear]="true" [selectedIndex]="currentStep">
        <mat-step [stepControl]="form1.control" [editable]="true"
                  *ngIf="applicant && !keyIdentifier.loanPurposeConfig?.hideAdditionalInfoStep && hasAdditionalInfoSections">
            <form id="primaryApplicantDetails" class="m-form m-form--group-seperator-dashed" #form1="ngForm" data-test-id="review.form">
                <ng-template matStepLabel>Additional Information</ng-template>
                <div class="vertical-stack-32">
                    <ng-container *ngIf="!keyIdentifier.isCoBoConsentFlow &&
                                        applicant && !keyIdentifier.loanPurposeConfig?.hideAdditionalInfoStep &&
                                        (miscellaneousFieldsConfig?.mothersMaidenName ||
                                         miscellaneousFieldsConfig?.last4ssn ||
                                         miscellaneousFieldsConfig?.homePhone ||
                                         miscellaneousFieldsConfig?.workPhone ||
                                         miscellaneousFieldsConfig?.ssn)">
                        <cs-additional-info [(ngModel)]="applicant" name="additionalInfo" [submitted]="form1.submitted"
                                            [finalSubmitPageConfig]="finalSubmitPageConfig"
                                            [miscellaneousFieldsConfig]="miscellaneousFieldsConfig"
                                            [applicant]="applicant"
                                            data-test-id="review.additional-info"></cs-additional-info>
                    </ng-container>

                    <ng-container *ngIf="finalSubmitPageConfig.collectID">
                        <cs-identity-info #identityInfo [(ngModel)]="applicant" name="identityInfo" data-test-id="review.identity-info"></cs-identity-info>
                    </ng-container>


                    <ng-container
                        *ngIf="!keyIdentifier.isCoBoConsentFlow && (appConfig.finalSubmitPage.grossAnnualIncome || appConfig.finalSubmitPage.rentMortgagePmt)">
                        <div class="m-form__group">
                            <div class="row">
                                <div class="{{cssWidthClass}} currency-input"
                                     *ngIf="!appConfig || appConfig.finalSubmitPage.grossAnnualIncome">
                                    <mat-form-field class="mat-form-field-fluid">
                                        <mat-label data-test-id="review.gross-annual-income-label">Gross Annual Income</mat-label>
                                        <input matInput type="tel" name="income" curreny-format
                                               [(ngModel)]="employment.salaryString" #salaryString="ngModel" required
                                               data-test-id="review.gross-annual-income-input"/>
                                        <span matPrefix>$&nbsp;</span>
                                        <span matSuffix>.00</span>
                                        <mat-hint data-test-id="review.gross-annual-income-hint">Your before tax Gross Annual Income can include bonuses,
                                            commissions, tips, alimony, child support, etc. Please do not include
                                            non-applicant
                                            income
                                        </mat-hint>
                                        <mat-error *ngIf="salaryString.hasError('required')" data-test-id="review.gross-annual-income.required-error">Please enter gross annual income.</mat-error>
                                        <mat-error *ngIf="salaryString.hasError('min-max')" data-test-id="review.gross-annual-income.min-max-error">Gross Annual Income must be
                                            greater
                                            than {{ keyIdentifier.loanPurposeConfig && keyIdentifier.loanPurposeConfig.minAnnualIncome || 100 | currency:'USD':'symbol':'1.0-0' }}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="{{cssWidthClass}} currency-input"
                                     *ngIf="!appConfig || appConfig.finalSubmitPage.rentMortgagePmt">
                                    <mat-form-field class="mat-form-field-fluid">
                                        <mat-label data-test-id="review.rent-mortgage-label">Rent/Mortgage Pmt($)</mat-label>
                                        <input matInput type="tel" name="residenceCost"

                                               [(ngModel)]="residence.cost" #costString="ngModel" curreny-format required
                                               data-test-id="review.rent-mortgage-input"/>
                                        <span matPrefix>$&nbsp;</span>
                                        <span matSuffix>.00</span>

                                        <mat-error *ngIf="costString.hasError('required')" data-test-id="review.rent-mortgage.required-error">Please enter housing cost.</mat-error>
                                        <mat-hint align="start" data-test-id="review.rent-mortgage-hint">
                                            Estimate monthly housing cost. Homeowners, include all mortgage payments (first
                                            &
                                            second mortgages, and home equity loans). Renters, please enter monthly rent
                                        </mat-hint>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <!---------- Security Pin ------------>
                    <div *ngIf="appConfig.phonePin && !keyIdentifier.isCoBoConsentFlow">
                        <h2 class="section-title" data-test-id="review.security-pin-title">Security PIN</h2>
                        <div class="row">
                            <div class="col-sm-12">
                                <mat-label class="d-block mb-2" data-test-id="review.security-pin-label">
                                    For added security of your account and access to 24 hour telephone banking,
                                    please enter a 4 digit PIN number:
                                </mat-label>
                                <mat-form-field class="mat-form-field-fluid" data-test-id="review.phone-pin-field">
                                    <input matInput name="phonePin" type="tel" required #phonePinModel="ngModel"
                                           autocomplete="off" inputmode="numeric" min-max maxlength="4" minlength="4"
                                           pattern="[0-9]*" [(ngModel)]="phonePin"
                                           data-test-id="review.phone-pin-input"/>
                                    <mat-error *ngIf="phonePinModel.hasError('required')" data-test-id="review.phone-pin.required-error">
                                        Please enter a four digit PIN number.
                                    </mat-error>
                                    <mat-error *ngIf="phonePinModel.hasError('pattern')" data-test-id="review.phone-pin.pattern-error">
                                        Only numeric values are allowed.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <!-- Employment history-->
                    <ng-container *ngIf="finalSubmitPageConfig.employmentHistory">
                        <cs-employment-info #employmentInfo [applicant]="applicant"
                                            [occupationCollected]="occupationCollected"
                                            data-test-id="review.employment-info"></cs-employment-info>
                    </ng-container>

                    <!-- Residence history-->
                    <ng-container *ngIf="finalSubmitPageConfig.residencyHistory || appConfig.mailingAddress">
                        <cs-residence-info class="vertical-stack-32" #residenceInfo [applicant]="applicant" data-test-id="review.residence-info"></cs-residence-info>
                    </ng-container>
                </div>

                <div class="page-actions">
                    <!-- <button data-test-id="review.back-button" class="mr-3" type="button" color="primary" mat-stroked-button (click)="goToPrevStep($event)">Back</button>-->
                    <mat-bar-button id="reviewPageNextBtn1" [options]="getButtonOptions(showSubmitOnAdditionalInfoStep)"
                                    (tsSubmitIfValid)="onSubmit(1)" data-test-id="review.additional-info.next-button"></mat-bar-button>
                </div>
            </form>
        </mat-step>

        <mat-step *ngIf="finalSubmitPageConfig.authorizedUser && !keyIdentifier.isCoBoConsentFlow && !isYouthKidAccount &&
                         !(institutionSettings.flow === '2' && isYouthAccount)" [stepControl]="form2.control" [editable]="true">
            <form id="coborrowerApplicantDetails" class="m-form m-form--group-seperator-dashed" #form2="ngForm" data-test-id="review.authorized-user.form">
                <ng-template matStepLabel>Add {{ contentService.getContentText('AUTHORIZED_USER_TEXT') }}?
                </ng-template>
                <mat-checkbox *ngIf="!coborrowerApplicant.applicantId" name="authorizedUserRequired1" class="text-sm-center text-start" [ngClass]="{'mb-18': authorizedUserRequired}"
                              [(ngModel)]="authorizedUserRequired"
                              [style.display]="(keyIdentifier.isGuardianRequired || isYouthAccount) ? 'none' : 'block'"
                              #authorizedUserRequired1="ngModel"
                              data-test-id="review.authorized-user-checkbox">
                    <span class="m--regular-font-size-lg3" data-test-id="review.authorized-user-checkbox-text">I want to add {{ contentService.getContentText('AUTHORIZED_USER_TEXT') }}
                        for account access?</span>

                </mat-checkbox>

                <ng-container *ngIf="authorizedUserRequired">
                    <cs-authorized-user #authorizedUser [applicant]="coborrowerApplicant"
                                        [primaryApplicant]="applicant" data-test-id="review.authorized-user"></cs-authorized-user>
                </ng-container>

                <div class="page-actions">
                    <button id="reviewPageBackBtn2" type="button" color="primary" mat-stroked-button
                            (click)="goToPrevStep($event)" data-test-id="review.authorized-user.back-button">Back
                    </button>
                    <mat-bar-button id="reviewPageNextBtn2" [options]="getButtonOptions(showSubmitOnAuthorizedUserStep)"
                                    (tsSubmitIfValid)="onSubmit(2)" data-test-id="review.authorized-user.next-button"></mat-bar-button>
                </div>
            </form>
        </mat-step>

        <mat-step *ngIf="appConfig.survivorshipBeneficiary && !keyIdentifier.isCoBoConsentFlow && !keyIdentifier?.loanPurposeConfig?.isBusinessProduct" [stepControl]="form3.control" [editable]="true">
            <form class="m-form m-form--group-seperator-dashed" #form3="ngForm" data-test-id="review.beneficiary.form">
                <ng-template matStepLabel>Beneficiary</ng-template>
                <div class="row">
                    <div class="col-md-12 text-sm-center text-start" [ngClass]="{'mb-18': survivorshipBeneficiary}">
                        <mat-checkbox class="d-block text-start" id="survivorship-beneficiary" name="survivorshipBeneficiary" [(ngModel)]="survivorshipBeneficiary"
                                      #survivorshipBeneficiaryDom="ngModel"
                                      data-test-id="review.beneficiary-checkbox">
                            <span class="m--regular-font-size-lg3" data-test-id="review.beneficiary-checkbox-text">I want to add {{ contentService.getContentText('BENEFECIARY_TEXT') }}</span>
                            <span class="d-block font-12px" *ngIf="contentService.getContentText('BENEFECIARY_DESCRIPTION_TEXT')"
                                  data-test-id="review.beneficiary-description-text">{{ contentService.getContentText('BENEFECIARY_DESCRIPTION_TEXT') }}</span>
                        </mat-checkbox>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <ng-container *ngIf="survivorshipBeneficiary">
                            <cs-beneficiary #beneficiaryComponent [beneficiaryApplicants]="beneficiaryApplicants"
                                            [coborrowerApplicant]="coborrowerApplicant"
                                            [authorizedUserRequired]="authorizedUserRequired" (event)="beneficiaryPercentageError($event)"
                                            data-test-id="review.beneficiary"></cs-beneficiary>
                        </ng-container>
                    </div>
                </div>
                <div class="page-actions">
                    <button id="reviewPageBackBtn3" class="mr-3" type="button" color="primary" mat-stroked-button
                            (click)="goToPrevStep($event)" data-test-id="review.beneficiary.back-button">Back
                    </button>
                    <mat-bar-button id="reviewPageNextBtn3" [options]="getButtonOptions(showSubmitOnBeneficiaryStep)" [disabled]="percentageError"
                                    (tsSubmitIfValid)="onSubmit(3)" data-test-id="review.beneficiary.next-button"></mat-bar-button>
                </div>
            </form>
        </mat-step>

        <mat-step *ngIf="finalSubmitPageConfig.reference && !keyIdentifier.isCoBoConsentFlow && !keyIdentifier?.loanPurposeConfig?.isBusinessProduct" [stepControl]="form4.control"
                  [editable]="true">
            <form id="otherApplicantsDetails" class="m-form m-form--group-seperator-dashed" #form4="ngForm" data-test-id="review.reference-applicant.form">
                <!-- Employment history-->
                <ng-container *ngIf="finalSubmitPageConfig.reference">
                    <cs-reference-applicant [(ngModel)]="referenceApplicant"
                                            name="referenceApplicant" data-test-id="review.reference-applicant"></cs-reference-applicant>
                </ng-container>

                <div class="page-actions">
                    <button id="reviewPageBackBtn4" class="mr-3" type="button" color="primary" mat-stroked-button
                            (click)="goToPrevStep($event)" data-test-id="review.reference-applicant.back-button">Back
                    </button>
                    <mat-bar-button id="reviewPageNextBtn4" [options]="step1ButtonOptions"
                                    (tsSubmitIfValid)="onSubmit(4)" data-test-id="review.reference-applicant.next-button"></mat-bar-button>
                </div>
            </form>
        </mat-step>

        <!-- BUSINESS PRODUCT -->
        <ng-container *ngIf="keyIdentifier?.loanPurposeConfig?.isBusinessProduct && !keyIdentifier.isCoBoConsentFlow">
            <!-- Additional info -->
            <mat-step [stepControl]="form5.control">
                <form id="additionalInformationForm" class="m-form m-form--group-seperator-dashed" #form5="ngForm" data-test-id="review.additional-information.form">
                    <creditsnap-additional-information name="additionalInformation"
                                                       *ngIf="companyApplicant"
                                                       [(ngModel)]="companyApplicant"
                                                       data-test-id="review.additional-information">
                    </creditsnap-additional-information>
                    <div class="page-actions">
                        <button id="reviewPageBackBtn5" class="mr-3" type="button" color="primary" mat-stroked-button
                                (click)="goToPrevStep($event)" data-test-id="review.additional-information.back-button">Back
                        </button>
                        <mat-bar-button id="reviewPageNextBtn5" [options]="step1ButtonOptions"
                                        (tsSubmitIfValid)="onSubmit(5)" data-test-id="review.additional-information.next-button"></mat-bar-button>
                    </div>
                </form>
            </mat-step>

            <!-- Additional Owners -->
            <mat-step [stepControl]="form6.control">
                <form id="additionalOwnersForm" class="m-form m-form--group-seperator-dashed" #form6="ngForm" data-test-id="review.additional-owners.form">
                    <creditsnap-additional-owners name="additionalOwners"
                                                  [(ngModel)]="otherOwners"
                                                  data-test-id="review.additional-owners">
                    </creditsnap-additional-owners>
                    <div class="page-actions">
                        <button id="reviewPageBackBtn6" class="mr-3" type="button" color="primary" mat-stroked-button
                                (click)="goToPrevStep($event)" data-test-id="review.additional-owners.back-button">Back
                        </button>
                        <mat-bar-button id="reviewPageNextBtn6" [options]="step1ButtonOptions"
                                        (tsSubmitIfValid)="onSubmit(6)" data-test-id="review.additional-owners.next-button"></mat-bar-button>
                    </div>
                </form>
            </mat-step>

            <!-- Controlling Manager -->
            <mat-step [stepControl]="form7.control">
                <form id="controllingManagersForm" class="m-form m-form--group-seperator-dashed" #form7="ngForm" data-test-id="review.controlling-manager.form">
                    <creditsnap-controlling-manager name="controllingManagers"
                                                    [(ngModel)]="controllingManager" data-test-id="review.controlling-manager"></creditsnap-controlling-manager>

                    <div class="page-actions">
                        <button id="reviewPageBackBtn7" class="mr-3" type="button" color="primary" mat-stroked-button
                                (click)="goToPrevStep($event)" data-test-id="review.controlling-manager.back-button">Back
                        </button>
                        <mat-bar-button id="reviewPageNextBtn7" [options]="step1ButtonOptions"
                                        (tsSubmitIfValid)="onSubmit(7)" data-test-id="review.controlling-manager.next-button"></mat-bar-button>
                    </div>
                </form>
            </mat-step>

            <!-- BUSINESS PRODUCT -->
        </ng-container>

        <!-- Custom Questions -->
        <ng-container *ngIf="showAdditionalQuestions && !keyIdentifier.isCoBoConsentFlow">
            <mat-step [stepControl]="form8.control"
                      [editable]="true">
                <form id="customQuestionFrom" class="m-form m-form--group-seperator-dashed" #form8="ngForm" data-test-id="review.primary-custom-questions.form">
                    <creditsnap-custom-questions [application]="application"
                                                 [applicant]="applicant"
                                                 [selectedSubProducts]="selectedSubProducts"
                                                 name="primary"
                                                 data-test-id="review.primary-custom-questions"
                    ></creditsnap-custom-questions>
                    <div class="page-actions">
                        <button id="customQuestionBackBtn8" class="mr-3" type="button" color="primary"
                                mat-stroked-button (click)="goToPrevStep($event)" data-test-id="review.primary-custom-questions.back-button">Back
                        </button>
                        <mat-bar-button id="customQuestionNextBtn8" [options]="step1ButtonOptions"
                                        (tsSubmitIfValid)="onSubmit(8)" data-test-id="review.primary-custom-questions.next-button"></mat-bar-button>
                    </div>
                </form>
            </mat-step>
        </ng-container>
        <ng-container *ngIf="showAdditionalQuestions && keyIdentifier.isCoBoConsentFlow && showCoBoAdditionalQuestions">
            <mat-step [stepControl]="form9.control"
                      [editable]="true">
                <form id="customQuestionFrom" class="m-form m-form--group-seperator-dashed" #form9="ngForm" data-test-id="review.coborrower-custom-questions.form">
                    <creditsnap-custom-questions [application]="application"
                                                 [applicant]="coborrowerApplicant"
                                                 [selectedSubProducts]="selectedSubProducts"
                                                 name="secondary"
                                                 data-test-id="review.coborrower-custom-questions"
                    ></creditsnap-custom-questions>
                    <div class="page-actions">
                        <button id="customQuestionBackBtn9" class="mr-3" type="button" color="primary"
                                mat-stroked-button (click)="goToPrevStep($event)" data-test-id="review.coborrower-custom-questions.back-button">Back
                        </button>
                        <mat-bar-button id="customQuestionNextBtn9" [options]="step1ButtonOptions"
                                        (tsSubmitIfValid)="onSubmit(9)" data-test-id="review.coborrower-custom-questions.next-button"></mat-bar-button>
                    </div>
                </form>
            </mat-step>
        </ng-container>

        <!-- Primary applicant consents. A co-applicant handed over from /consent gives their consent
             through the final consent modal at the end of this page instead. -->
        <mat-step [editable]="true" *ngIf="!isCoApplicantOnReviewPage &&
                                 ((!(keyIdentifier.applicationType === 'I' && keyIdentifier.preApprovalApplicationId) && (consentsConfig?.finalConsent_individual?.text || displayConsents.length > 0) && !keyIdentifier.loanPurposeConfig.isBusinessProduct) ||
                                 (keyIdentifier.loanPurposeConfig.isBusinessProduct && appConfig.business_consent))">
            <form id="consentForm" class="m-form m-form--group-seperator-dashed" #form6="ngForm" data-test-id="review-consent.form">
                <ng-container *ngIf="appConfig?.consentsConfigDeposit">
                    <div *ngFor="let consent of displayConsents; let i = index; let last = last" class="form-check"
                            [ngClass]="{ 'mb-32': !last }">
                        <div *ngIf="consent.text"
                             class="col-sm-12">
                            <mat-checkbox [checked]="selectedConsents.includes(i)" (change)="onConsentChange($event.checked, i)"
                                          class="consent1" name="consent{{ i }}" [required]="consent.required" class="mb-12"
                                          [attr.data-test-id]="'review-consent.deposit-consent-checkbox.' + i">
                                <span [innerHTML]="consent.text | safe:'html'"
                                      class="content-text" [attr.data-test-id]="'review-consent.deposit-consent-text.' + i">
                                </span>

                            </mat-checkbox>

                            <div *ngIf="!selectedConsents.includes(i) && consent.required && showErrors" class="mat-error"
                                 [attr.data-test-id]="'review-consent.deposit-consent.required-error.' + i">
                                Please provide your consent to continue.
                            </div>
                        </div>
                    </div>

                </ng-container>
                <ng-container
                    *ngIf="(!(keyIdentifier.applicationType === 'I' && keyIdentifier.preApprovalApplicationId) && consentsConfig?.finalConsent_individual?.text && !keyIdentifier.loanPurposeConfig.isBusinessProduct) && !appConfig?.conesntsConfigDeposit">
                    <div class="row">
                        <div class="col-sm-12">
                            <div *ngIf="finalConsent_individual.invalid && (finalConsent_individual.dirty || finalConsent_individual.touched)"
                                 class="mat-error" data-test-id="review-consent.individual-consent.required-error">
                                Please provide your consent to continue.
                            </div>
                            <mat-checkbox #finalConsent_individual="ngModel"
                                          [(ngModel)]="consent.finalConsent_individual"
                                          [checked]="consent.finalConsent_individual" class="consent1"
                                          name="finalConsent_individual"
                                          [required]="consentsConfig.finalConsent_individual.required"
                                          data-test-id="review-consent.individual-consent-checkbox">
                                            <span
                                                [innerHTML]="consentsConfig.finalConsent_individual.text | safe:'html'"
                                                [ngClass]="{'showFull': showConsent3}"
                                                class="content-text"
                                                data-test-id="review-consent.individual-consent-text"
                                                style="max-height: none; overflow: visible; white-space: normal;"></span>
                            </mat-checkbox>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="keyIdentifier.loanPurposeConfig.isBusinessProduct && appConfig.business_consent">
                    <div class="row mt-5 m-form__section--consent">
                        <div class="col-sm-12">
                            <div
                                *ngIf="businessConsent.invalid && (businessConsent.dirty || businessConsent.touched)"
                                class="mat-error" data-test-id="review-consent.business-consent.required-error">
                                Please provide your consent to continue.
                            </div>
                            <mat-checkbox name="businessConsent" [checked]="consent.softInquiryConsent" class="consent1"
                                          [(ngModel)]="consent.softInquiryConsent" required
                                          #businessConsent="ngModel"
                                          data-test-id="review-consent.business-consent-checkbox">
                                <span class="content-text" [ngClass]="{'showFull': showConsent1}"
                                      data-test-id="review-consent.business-consent-text"
                                      [innerHTML]="appConfig.business_consent | replaceString: {'submitButtonText': 'Submit Application'} | safe:'html'"></span>
                                <a href="javascript:" id="readMoreLink2"
                                   (click)="showConsent1 = !showConsent1" data-test-id="review-consent.business-consent-read-more">{{ showConsent1 ? 'Read Less ...' : 'Read More ...' }}</a>
                            </mat-checkbox>
                        </div>
                    </div>
                </ng-container>

                <div class="main-title" *ngIf="errorTransaction" data-test-id="review-consent.error-message">
                    <p data-test-id="review-consent.error-message-text">
                        Oops, something unexpected happened! Please try again.
                    </p>
                </div>
                <div class="page-actions" *ngIf="finance">

                    <button id="reviewPageBackBtn" class="mr-3" type="button" color="primary" mat-stroked-button
                            (click)="goToPrevStep($event)" data-test-id="review-consent.back-button">
                        Back
                    </button>
                    <mat-bar-button id="finalSubmitButton" [options]="step1ButtonOptions"
                                    (tsSubmitIfValid)="onSubmit(10)" data-test-id="review-consent.submit-button"></mat-bar-button>
                </div>
            </form>
        </mat-step>
    </mat-stepper>
</ng-container>
